import { c as _c } from "react/compiler-runtime";
import { Icon } from '@/app/components/icons';
import { IconAdd } from '@/app/components/icons/ui-actions/icon-add';
import type { HotspotItemProps } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/engine-story/hotspots/hotspot-item/types';
import { SPARTAN_ENGINE_HERO_DATA_GA, SPARTAN_ENGINE_HERO_TRACKING } from '@/app/lcv/components/sections/spartan/engine/sections/hero-animation/tracking';
import styles from '@/app/lcv/components/sections/spartan/engine/styles.module.css';
import { SPARTAN_ENGINE_EVENT_NAME } from '@/app/lcv/components/sections/spartan/engine/tracking';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { buildHtmlMarkup } from '@/app/utils/html/html';
export const HotspotItem = t0 => {
  const $ = _c(21);
  const {
    className,
    hotspotId,
    index,
    title,
    onClick,
    isActive: t1
  } = t0;
  const isActive = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== className || $[1] !== isActive) {
    t2 = cn("cursor-pointer text-white", styles.hotspot, {
      [styles.active]: isActive
    }, className);
    $[0] = className;
    $[1] = isActive;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== index) {
    t3 = createDataAttributes({
      test: SPARTAN_ENGINE_HERO_TRACKING.hotspot(index)
    });
    $[3] = index;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== hotspotId || $[6] !== title) {
    t4 = createDataGA({
      eventName: SPARTAN_ENGINE_EVENT_NAME,
      group: SPARTAN_ENGINE_HERO_DATA_GA.hotspot,
      click: true,
      text: title,
      value: hotspotId
    });
    $[5] = hotspotId;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon icon={<IconAdd />} className={cn("center-x center-y ease-bounce absolute z-10 text-red-500")} />;
    t6 = cn("center-y absolute flex h-full items-center pr-6", styles.textContainer);
    t7 = cn("text-body-1-fixed font-noto-bold relative z-10 whitespace-nowrap", styles.textWrap);
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== title) {
    t8 = buildHtmlMarkup(title);
    $[11] = title;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <div className={t6}><div className={t7} dangerouslySetInnerHTML={t8} /></div>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== onClick || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t9) {
    t10 = <button type="button" aria-haspopup="dialog" className={t2} onClick={onClick} {...t3} {...t4}>{t5}{t9}</button>;
    $[15] = onClick;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};